import InfoUser from "@/views/user/InfoUser";

export default [
  {
    path: '/usuario/detalles-contacto/:idUser',
    name: 'userDetails',
    component: InfoUser,
    meta: {
      title: 'Detalles de contacto de usuario',
      requiresAuth: true,
      requiresObipetsAdmin: false
    },
  }
]
